<div
  [ngClass]="{'iot-platform-ui-resize-handle--mobile': isXSmallScreen()}"
  class="iot-platform-ui-resize-handle"
  (mousedown)="onResizeStart($event)"
  (touchstart)="onResizeStart($event)"
>
  <mat-icon class="iot-platform-ui-resize-handle__resize-icon">drag_indicator</mat-icon>
</div>
